export default __webpack_public_path__ + "static/media/dobri_xl.02865889.jpg";